import { motion } from 'framer-motion';
import { styled } from 'styled-components';

import { fadeStaggerParent, fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import { framerMotion, styledReset } from '@pkg/primitives';

export const Wrapper = styled(motion.div).attrs({
    variants: fadeStaggerParent,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
})`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 11px;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    }
`;

export const CardWrapper = styled(motion.div).attrs({
    variants: fadeVariants,
    transition: {
        ...fadeTransition,
        duration: framerMotion.duration.slowest,
    },
})`
    position: relative;
    display: flex;
`;

export const HiddenBadge = styled.div`
    ${styledReset.typography};
    padding: 2px 4px 4px;
    border-radius: 3px;
    background: radial-gradient(1781.76% 135.63% at 102.93% 143.75%, #000 0%, #47467c 100%);
    box-shadow:
        0 0 30px 0 rgba(99, 89, 138, 0.6) inset,
        0 0 24px 0 rgba(177, 160, 247, 0.35);

    letter-spacing: -0.24px;
    font-size: 10px;
    position: absolute;
    top: 17px;
    left: 42px;
    font-weight: 700;
    z-index: 10;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        left: 14px;
        top: 15px;
        font-size: 12px;
        border-radius: 5px;
    }
`;
